import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import budgetReducer from './slices/budget';
import catalogReducer from './slices/catalog';
import adminReportsReducer from './slices/adminReports';
import dashboardReducer from './slices/dashboard';
import emailRecipientReducer from './slices/emailRecipient';
import invoicingReducer from './slices/invoicing';
import contractsReducer from './slices/contracts';
import notificationsReducer from './slices/notifications';
import orderGuidesReducer from './slices/orderGuides';
import ordersReducer from './slices/orders';
import orderSheetReducer from './slices/orderSheet';
import rentalsReducer from './slices/rentals';
import reportsReducer from './slices/reports';
import ticketReducer from './slices/tickets';
import transitionsReducer from './slices/transitions';
import transportsReducer from './slices/transports';
import userReducer from './slices/user';
import usersReducer from './slices/users';
import vendorsReducer from './slices/vendors';

// ----------------------------------------------------------------------
export const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

export const userPersistConfig = {
  key: 'cart',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['user'],
};

const appReducer = combineReducers({
  budget: budgetReducer,
  catalog: catalogReducer,
  adminReports: adminReportsReducer,
  dashboard: dashboardReducer,
  contracts: contractsReducer,
  invoicing: invoicingReducer,
  notifications: notificationsReducer,
  orderGuides: orderGuidesReducer,
  orderSheet: orderSheetReducer,
  orders: ordersReducer,
  tickets: ticketReducer,
  user: persistReducer(userPersistConfig, userReducer),
  users: usersReducer,
  vendors: vendorsReducer,
  emailRecipient: emailRecipientReducer,
  rentals: rentalsReducer,
  reports: reportsReducer,
  transitions: transitionsReducer,
  transports: transportsReducer,
});

const rootReducer = (state, action) => {
  if (action.type === 'RESET_STORES') {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
